module.exports = __webpack_public_path__ + "img/00 banner.0a2c98d3.png";